/*=========================================================================================
  File Name: moduleDashboardState.js
  Description: Dashboard Module State
==========================================================================================*/

export default {
	devices: [],
	devicesStatus: [],
	sensorAlerts: [],
	categories: [],
	isFetchedDevices: false,
	isFetchedSensorAlerts: false
};
